/**
 * 終了メッセージの開閉
 *
 * @param {number} move_function   移動先番号
 * @author hayakawa 2023.10.18
 */

// インポート
import { auto_show_time, auto_hide_time } from './_constants';
import { movePagefromModal } from './move_page_from_modal';

// 定数
const $flash_message = $('#flash-message'),
    $auto_show_hide = $flash_message.find('.auto-show-hide');

// 処理
$(function() {
    // 終了メッセージ表示
    setTimeout(function() {
        $auto_show_hide.slideDown();
    }, auto_show_time);

    // 終了メッセージ非表示
    setTimeout(function() {
        $auto_show_hide.slideUp();
        // 終了メッセージ表示後にページ移動
        if (document.getElementById('move-page') != null) {
            move_function = $('#move-page').find('[name=move_function]').val();
            if (move_function > 0) {
                movePagefromModal();
            }
        } else if ($('[name=move_function]').length > 0) {
            move_function = $('[name=move_function]').val();
            if (move_function > 0) {
                movePagefromModal();
            }
        }
    }, auto_hide_time);
});
